/**
 * CriteriaLevelSelect
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { Icon } from 'ui-component-library/base';
/** Main description for this component. */
var CriteriaLevelSelect = function (_a) {
    var children = _a.children, showDetailsText = _a.showDetailsText, hideDetailsText = _a.hideDetailsText;
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var renderChildren = function (children) {
        return React.Children.map(children, function (child, index) {
            return React.cloneElement(child, __assign(__assign({}, child.props), { expanded: expanded, criteriaLevelId: "criteria-level-" + (index + 1) }) || {});
        });
    };
    var getCriteriaLevelIds = function () {
        var criteriaLevelIds = React.Children.map(children, function (child, index) { return "criteria-level-" + (index + 1); });
        return criteriaLevelIds === null || criteriaLevelIds === void 0 ? void 0 : criteriaLevelIds.toString().replace(/,/g, ' ');
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "md:flex md:flex-row md:flex-nowrap md:items-stretch" }, renderChildren(children)),
        React.createElement("div", { className: "text-center w-full mt-6" },
            React.createElement("button", { className: "text-h3 text-teal", "aria-expanded": expanded, "aria-controls": getCriteriaLevelIds(), onClick: function () { return setExpanded(!expanded); } }, expanded ? (React.createElement("span", null,
                hideDetailsText,
                React.createElement(Icon, { icon: "chevron", direction: "down", className: "ml-2" }))) : (React.createElement("span", null,
                showDetailsText,
                React.createElement(Icon, { icon: "chevron", direction: "up", className: "ml-2" })))))));
};
export default CriteriaLevelSelect;
